import { InfoBanner } from "@screencloud/screencloud-ui-components";
import { type InjectedIntlProps, injectIntl } from "react-intl";

/**
 * Informational banner shown when the Invoice payment method is selected.
 * Mirrors the billinglatest invoice notice — no fields to fill; the actual
 * `createPaymentSourceInvoice` call happens at Checkout.
 */
function InvoiceNoticeBase({ intl }: InjectedIntlProps) {
  return (
    <InfoBanner
      color="warning"
      icon="info"
      data-testid="invoice-notice"
      description={intl.formatMessage({
        id: "pixi_wizard.payment_shipping.invoice_notice",
        defaultMessage:
          "Invoice billing is available as an annual option only, with a minimum license of 5 screens.",
      })}
    />
  );
}

export const InvoiceNotice = injectIntl(InvoiceNoticeBase);
